import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const addressContactRelationDataClassName =
  DataClassName.ADDRESS_CONTACT_RELATION
const addressContactRelationEndpoint = PisaDataClassEndpoint.ADDRESS_CONTACT

export function pisaAddressContactRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(addressContactRelationDataClassName, {
    title: addressContactRelationDataClassName,
    restApi: createPisaRestApiConfig(addressContactRelationEndpoint),
    attributes,
  })
}
